export const DEFAULT_MODELS = [{ name: 'gpt-3.5-turbo' }];

export const APPID = 2;

export enum Path {
  Login = '/home',
  Home = '/',
  Chat = '/chat',
  Dataset = '/dataset',
  DatasetDetail = '/app/datasetDetail/:id',
  FileDetail = '/fileDetail/:id',
  AppMarket = '/appMarket',
  BuildApp = '/build',
  Manage = '/manage',
  API = '/api',
}

export enum SlotID {
  AppBody = 'app-body',
  SideBar = 'side-bar',
  AppInfo = 'app-info',
  Expand = 'side-bar-expand',
  DisableSectionMsg = 'disable-section-msg',
  AppBuildBody = 'app-build-body',
  DebugFrame = 'debug-policy',
}

export const SIDEBAR_WIDTH = 300;
export const MIN_CHAT_WIDTH = 640;
export const APPINFO_WIDTH = 360;
export const APP_BUILD_PAGE_COLLAPSE_WIDTH = 1080;

export const LAST_INPUT_KEY = 'last-input';

// export const REQUEST_TIMEOUT_MS = 5000;
export const REQUEST_TIMEOUT_MS = 1200000;

export const QUEUE_UPDATE_TIME = 5000; // 排队信息更新间隔

export const REQUEST_RETRY_TIME = 1000; // 会话长连接重试间隔

export const OpenaiPath = {
  ChatPath: '/v1/chat/completions',
  FilePath: '/v1/chat/completions/file',
  DebugPath: '/v1/chat/test/completions',
  UsagePath: 'dashboard/billing/usage',
  SubsPath: 'dashboard/billing/subscription',
  ListModelPath: 'v1/models',
};

export const DEFAULT_INPUT_TEMPLATE = `{{input}}`; // input / time / model / lang

export enum EventName {
  Side_Bar_Expand = 'side-bar-expand',
  App_Info_Normal = 'app-info-normal', // 右侧部分由浮层切换至正常展示
  Side_Bar_Hide = 'side-bar-hide',
  Side_Bar_Normal = 'side-bar-normal',
  Chat_Webapp_Change = 'chat-webapp-change', // webcomponents窗口状态变化
}

type ENV_TYPE = 'dev' | 'test' | 'prod';
export const IframeHostMap = {
  dev: 'https://te.envhome.com', // 本地调试h5通信域名 http://localhost:10086
  test: 'https://te.envhome.com', // 测试环境h5通信域名
  prod: 'https://h5.envhome.com', // 正式环境h5通信域名
};
export const IframeHost = IframeHostMap[(process.env.APP_ENV as ENV_TYPE) || 'dev'];

export const LIMIT = 10000; // 输入字符限制
